import { api } from '@/api';

export interface GetChatFullDownloadRequest {
  chatId: string;
}

export interface GetChatFullDownloadResponse {
  downloadPath: string;
  downloadToken: string;
}

const getChatFullDownloadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getChatFullDownload: builder.mutation<GetChatFullDownloadResponse, GetChatFullDownloadRequest>({
      query: ({ chatId }) => ({
        url: '/chat/get-download',
        method: 'GET',
        params: { chat_id: chatId },
      }),
    }),
  }),
});

export const { useGetChatFullDownloadMutation } = getChatFullDownloadApi;
